import { render, staticRenderFns } from "./NewVideo.vue?vue&type=template&id=12bcd863&scoped=true"
import script from "./NewVideo.vue?vue&type=script&lang=js"
export * from "./NewVideo.vue?vue&type=script&lang=js"
import style0 from "./NewVideo.vue?vue&type=style&index=0&id=12bcd863&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bcd863",
  null
  
)

export default component.exports